import { gatewayPhone } from "src/gateways/gatewayPhone";

export type BlockedNumberRecord = {
  uid: string;
  companyId: number;
  phoneNumber: string;
};

export const blockedNumbersQueryKey = (companyId?: string | number | null) => ["blocked-numbers", companyId ?? null] as const;

export const normalizeBlockPhoneNumber = (value?: string | null): string => {
  if (!value) return "";

  const normalized = value.replace(/[^\d+]/g, "").trim();

  if (!normalized) return "";

  return normalized.startsWith("+") ? normalized : `+${normalized}`;
};

export const findBlockedNumber = (numbers: BlockedNumberRecord[], phoneNumber?: string | null): BlockedNumberRecord | null => {
  const normalized = normalizeBlockPhoneNumber(phoneNumber);

  if (!normalized) return null;

  return numbers.find((item) => normalizeBlockPhoneNumber(item.phoneNumber) === normalized) ?? null;
};

export const listBlockedNumbers = async (): Promise<BlockedNumberRecord[]> => {
  const { data } = await gatewayPhone.get<BlockedNumberRecord[]>("/blocked-numbers");
  return data;
};

export const blockPhoneNumber = async (phoneNumber: string): Promise<BlockedNumberRecord> => {
  const { data } = await gatewayPhone.post<BlockedNumberRecord>("/blocked-numbers", { phoneNumber });
  return data;
};

export const unblockPhoneNumber = async (uid: string): Promise<{ success: boolean }> => {
  const { data } = await gatewayPhone.delete<{ success: boolean }>(`/blocked-numbers/${uid}`);
  return data;
};
